module.exports = __webpack_public_path__ + "static/media/NumberCircle-04.bb4efd9a.svg";